// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HpQXq","notFoundContainer":"styles_notFoundContainer__3bj1B"};